import { Step } from 'react-joyride';

// Maps tour step targets to the sidebar group that must be expanded for them to be visible
export const practitionerStepGroupMap: Record<string, string> = {
  '[data-tour="practitioner-profile"]': 'My Practice',
  '[data-tour="practitioner-certifications"]': 'My Practice',
  '[data-tour="practitioner-availability"]': 'My Practice',
  '[data-tour="practitioner-services"]': 'My Practice',
  '[data-tour="practitioner-calendar"]': 'Client Management',
  '[data-tour="practitioner-appointments"]': 'Client Management',
  '[data-tour="practitioner-clients"]': 'Client Management',
  '[data-tour="practitioner-finances"]': 'Operations',
  '[data-tour="practitioner-reports"]': 'Operations',
  '[data-tour="practitioner-ai-content"]': 'Operations',
  '[data-tour="practitioner-ai-actions"]': 'Operations',
};

export const clientStepGroupMap: Record<string, string> = {
  '[data-tour="client-calendar"]': 'Sessions',
  '[data-tour="client-appointments"]': 'Sessions',
  '[data-tour="client-saved-practitioners"]': 'Sessions',
  '[data-tour="client-ai-navigator"]': 'Wellness',
  '[data-tour="client-tracking"]': 'Wellness',
  '[data-tour="client-profile"]': 'Account',
  '[data-tour="client-payment"]': 'Account',
};

export const clientTourSteps: Step[] = [
  {
    target: '[data-tour="client-home"]',
    title: 'Welcome to Your Dashboard',
    content: 'This is your homepage where you can view system notifications and important messages from practitioners.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="client-saved-practitioners"]',
    title: 'My Practitioners',
    content: 'View and manage your saved/favorited practitioners. Quickly access their profiles and book sessions.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-profile"]',
    title: 'Your Profile',
    content: 'Fill in your personal information and preferences here. Set your timezone first to avoid appointment time mistakes.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-calendar"]',
    title: 'Calendar View',
    content: 'View all your appointments in a calendar overview. Easily see your schedule at a glance.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-appointments"]',
    title: 'Appointments',
    content: 'Check and manage your upcoming and past sessions. You can message practitioners and view session details here.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-ai-navigator"]',
    title: 'AI Navigator (Reso)',
    content: 'Meet Reso, your personal AI wellness guide. Share how you feel and get personalized therapy recommendations, practitioner matches, and wellness insights.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-payment"]',
    title: 'Payment Methods',
    content: 'Add payment methods to book services. Your payment information is securely stored.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-tracking"]',
    title: 'Wellness Tracking',
    content: 'Track your wellness journey over time. Monitor your progress and see how your sessions are helping you grow.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-settings"]',
    title: 'Settings',
    content: 'Manage your account settings and notification preferences. You can also restart this guide anytime from here!',
    placement: 'right',
  },
];

export const practitionerTourSteps: Step[] = [
  {
    target: '[data-tour="practitioner-home"]',
    title: 'Welcome!',
    content: 'This is your dashboard homepage. View system messages, notifications, and important updates here.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="practitioner-profile"]',
    title: '1️⃣ Complete Your Profile',
    content: 'First step! Fill in your personal info, professional title, bio, location, and timezone so clients can find you.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-certifications"]',
    title: '2️⃣ Upload Certifications',
    content: 'Upload at least one valid certificate. The name on the certificate must match your profile. This is required before your services can go live.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-availability"]',
    title: '3️⃣ Set Availability',
    content: 'Configure your available time slots for bookings. Set your working hours and days off.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-services"]',
    title: '4️⃣ Add Services',
    content: 'Add the healing services you offer with pricing and duration. Services will go live after your certification is approved.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-calendar"]',
    title: 'Calendar View',
    content: 'View and manage your appointment calendar. See all your bookings at a glance.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-appointments"]',
    title: 'Appointments',
    content: 'Manage your upcoming and past sessions. Confirm bookings, message clients, and prepare for sessions here.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-clients"]',
    title: 'My Clients',
    content: 'View and manage your client list. Access client profiles, session history, and notes.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-finances"]',
    title: '5️⃣ Set Up Finances',
    content: 'Subscribe to a plan and connect your Stripe account to receive client payments. A subscription is required to accept bookings.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-reports"]',
    title: 'Reports',
    content: 'Access detailed reports on your bookings, revenue, and client engagement.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-ai-content"]',
    title: 'Content Posts',
    content: 'Create and manage marketing content to attract clients. Use AI-assisted writing to build your brand.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-ai-actions"]',
    title: 'AI Actions',
    content: 'Access powerful AI tools to help manage your practice, generate content, and streamline workflows.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-settings"]',
    title: 'Settings',
    content: 'Manage account settings, notification preferences, and integrations. You can restart this guide anytime from here!',
    placement: 'right',
  },
];
